import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoContactAction, 
  setIsFetching, 
  setFetchFailed, 
  setContactContent,
} from 'Components/InfoContact/Redux/actions';

export const fetchContactContent = () => {
  return async (dispatch: Dispatch<InfoContactAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoContact;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('ContactPage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.ContactPageViewModel = await response.json();
        dispatch(setContactContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoContact/Redux/thunks.tsx